import React from "react";
import Routers from "./Routers";
import CallBar from "./Components/CallBar";
import usePageTracking from "./hooks/usePageTracking";

function App() {
  usePageTracking();

  return (
    <div>
      <Routers />
      <CallBar />
    </div>
  );
}

export default App;
